module.exports = __webpack_public_path__ + "media/kuala lumpur/banana_food-2cfb781d.jpg";